export enum GroupSelection
{
    All = 0, //0 
    Room = 1, //1 
    Heat = 2, //2 
    Cool = 3, //3 
    Ventilation = 4, //4 
    Common = 5 //5
}